import { createContext, useEffect } from "react";
import Header from "./components/Header";
import Map from "./components/Map";
import { useState } from "react";
import axios from "axios";

export const Context = createContext();

function App() {
  const [address, setAddress] = useState();
  const [data, setData] = useState();

  return (
    <div className="App">
      <Context.Provider value={{ address, setAddress, data, setData }}>
        <Header />
        <Map />
      </Context.Provider>
    </div>
  );
}

export default App;
